import { useLayoutEffect } from 'react';

export const useFBShareRender = () => {
  useLayoutEffect(() => {
    const fb = window?.FB;
    fb && fb.XFBML && fb.XFBML.parse();
  }, []);
};
